var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"is-pulled-left"},[_c('router-link',{staticClass:"button",attrs:{"tag":"button","to":"/dashboard"}},[_c('b-icon',{attrs:{"icon":"arrow-alt-circle-left"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }